import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { winnersExportQueryKey } from 'hooks/api/Exports/useGetExportForWinnersByContestId'
import {
  type SweepstakeWinnerRequest,
  type FullSweepstakeWinner,
} from 'types/api'

export const usePutSweepstakeWinner = ({
  onError,
  onSuccess,
}: {
  onError: () => void | Promise<void>
  onSuccess: (data: FullSweepstakeWinner) => void | Promise<void>
}) => {
  const queryClient = useQueryClient()
  const putClient = useTypedApiClient({
    path: '/admin/sweepstake-winners/{id}',
    method: 'put',
  })
  return useMutation({
    mutationFn: async ({ req }: { req: SweepstakeWinnerRequest }) => {
      const { data } = await putClient({ ...req, id: Number(req.id) })
      return data
    },
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({ queryKey: winnersExportQueryKey })
      if (onSuccess) {
        await onSuccess(data)
      }
    },
    onError,
  })
}
